export const VIDEO_STREAM_KEY = 'vsk-r7x3m9';
